module.exports = __webpack_public_path__ + "static/STG20_Mobile_480_Module5_Drink3_Tonic-e4f7b8987553c56561c48ee6c949e249.png";